module.exports = __webpack_public_path__ + "static/media/avatar-22.e350a155.svg";